import { View } from "binder"
import { DebitCardSelectorViewModel } from "src/arap/rawData/debitCard/debitCardSelector-viewModel";
import { DebitGatewayViewModel } from "./debitGateway-viewModel"

export class DebitGatewayView extends View<DebitGatewayViewModel>{
    GetViewUniqueId(): string {
        return "V-7172FEF7-A92B-4DE3-A9DE-7E5151D06F12"
    }
    loadHtml(): string {
        let element = require('./debitGateway.html').default;
        let style = require('./debitGateway.less');
        return element;
    }
    constructor() {
       super();
    }

    public set sourceCardNo(v: string) { this._sourceCardNo = v; } public get sourceCardNo(): string { return this._sourceCardNo;} private _sourceCardNo: string;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode;} private _traceCode: string;
    public set debitCardSelector(v: DebitCardSelectorViewModel) { this._debitCardSelector = v; } public get debitCardSelector(): DebitCardSelectorViewModel { return this._debitCardSelector;} private _debitCardSelector: DebitCardSelectorViewModel;

}
